import { type ReactNode, useEffect } from "react";
import { cn, OverflowText, Sheet } from "ui";

type DrawerProps = {
  isOpen: boolean;
  onClose(): void;
  title: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  size?: "max-w-xs" | "max-w-md" | "max-w-lg" | "max-w-xl" | "max-w-none";
  className?: string;
};

export default function Drawer({
  isOpen,
  onClose,
  title,
  description,
  children,
  size = "max-w-md",
  className,
}: DrawerProps) {
  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <Sheet.Popup className={cn(`w-screen ${size}`, className)}>
        <Sheet.Header>
          <OverflowText render={<Sheet.Title />}>{title}</OverflowText>

          {description && <Sheet.Description>{description}</Sheet.Description>}
        </Sheet.Header>

        {children}
      </Sheet.Popup>
    </Sheet>
  );
}

const DrawerContent = ({
  className = "",
  ...props
}: React.ComponentProps<"div">) => {
  useEffect(() => {
    if (!window.Pylon) return;
    window.Pylon("hideChatBubble");
    return () => window.Pylon("showChatBubble");
  }, []);

  return <Sheet.Panel className={className} {...props} />;
};

const DrawerFooter = ({
  className = "",
  ...props
}: React.ComponentProps<"div">) => (
  <Sheet.Footer className={className} {...props} />
);

Drawer.Content = DrawerContent;
Drawer.Footer = DrawerFooter;
